import { useRef } from 'react';
import styled from 'styled-components';
import { SearchIcon } from '../TipSheetIcons/search-icon';
import { parseKeywords, formatKeywords } from '../../utils/keywordUtils';

const FormWrap = styled.div`
  position: relative;
  width: ${(props) =>
    props.$isMobile || props.$fullWidth ? '100%' : 'auto'};

  & svg {
    position: absolute;
    right: 0.5rem;
    top: 0.625rem;
  }

  @media (max-width: 768px) {
    display: ${(props) => (!props.$isMobile ? 'none' : 'block')};
  }
`;

const FilterTextBox = styled.input`
  border-radius: 0.25rem;
  border: 1px solid #cccccc;
  padding: ${(props) =>
    props.$isMobile ? '5px 0 4px 0' : '5px 2rem 4px 0.5rem'};
  text-indent: ${(props) => (props.$isMobile ? '0.5rem' : '0')};
  font-size: 0.875rem;
  line-height: 1.5;
  width: ${(props) =>
    props.$isMobile || props.$fullWidth ? '100%' : 'auto'};

  &::placeholder {
    color: #212121;
	font-size: 0.875rem;
  }
`;

const SearchButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 0.125rem;
  top: 0;
`;

export default function KeywordSearch({
  keywords,
  setKeywords,
  performSearch,
  isMobile = false,
  inputRef,
  searchInputRef,
  fullWidth = false,
}) {
  const localRef = useRef(null);
  const ref = inputRef || searchInputRef || localRef;

  const handleSubmit = (e) => {
    e.preventDefault();

    const rawInput = ref.current.value.trim();
    if (!rawInput) return;

    const inputTokens = parseKeywords(rawInput);
    if (inputTokens.length === 0) {
      ref.current.value = '';
      return;
    }

    // Replace existing keywords with the new input tokens (start a fresh search)
    const updatedKeywords = formatKeywords(inputTokens);
    setKeywords(updatedKeywords);

    // Perform search with the new keywords
    performSearch(updatedKeywords);

    // Clear input
    ref.current.value = '';
  };

  return (
    <FormWrap $isMobile={isMobile} $fullWidth={fullWidth}>
      <form onSubmit={handleSubmit}>
        <FilterTextBox
          ref={ref}
          placeholder="Enter a keyword"
          name="search"
          type="text"
          $isMobile={isMobile}
          $fullWidth={fullWidth}
        />
        <SearchButton type="submit">
          <SearchIcon />
        </SearchButton>
      </form>
    </FormWrap>
  );
}
